import React from 'react'
import MobileHomeLayout from '../../templates/mobileHome/MobileHomeLayout'
import MobileHomeContainer from '../../templates/mobileHome/MobileHomeContainer'

export default class MobileHomePage extends React.Component {
  routeToMobileFormPage = portalId => {
    this.props.history.push({
      pathname: '/mobile/portal/' + portalId,
    })
  }
  render() {
    return (
      <MobileHomeLayout>
        <MobileHomeContainer routeToMobileFormPage={this.routeToMobileFormPage}/>
      </MobileHomeLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/mobile/MobileHomePage.js